<template>
  <div style="padding-bottom: 60px">
    <!--<header>-->
      <!--<div class="headerDiv" v-on:click="backHistory"  @click="">-->
        <!--<img src="@/assets/img/back.png" alt="">-->
        <!--<p style="color: #FFFFFF"><van-search-->
          <!--v-model="name"-->
          <!--shape="round"-->
          <!--background="#6e9bcf"-->
          <!--placeholder="请输入搜索关键词"-->
          <!--v-on:input="getWrite"/></p>-->
      <!--</div>-->
    <!--</header>-->
    <header>
      <div class="headerDiv">
        <span @click="backHistory"><van-icon name="arrow-left" size="20" color="#ffffff" /></span>
        <div class="search" >

          <van-search
            v-model="name"
            shape="round"
            background="#ff2500"
            placeholder="请输入搜索关键词"
            />
        </div>
        <div class="searchIcon" v-on:click="getWrite">
          搜索
          <!--<van-icon color="#FFFFFF" size="25" name="shopping-cart-o" />-->
        </div>
      </div>
    </header>
    <div class="shopList">

      <!--<van-checkbox-group   >-->
      <div class="shopListDiv" v-for="(item,index) in list" @click="toShopDetail(item.id)">
        <div class="shopListDetails" >
          <div class="shopListDetailsImg">
            <img :src="item.img" alt="">
          </div>
          <div class="shopRoduct">
            <span class="shopSpan">{{item.title}}</span>
            <!--<span class="shopSpan" style="font-size: 14px"><span>{{item.subtitle}}</span></span>-->
            <span class="shopSpan" style="color:#f56723;font-size: 13px "><span>￥{{item.price}}</span></span>
            <div>
              <span class="borderShop" v-if="item.is_free_shipping==0">不包邮</span>
              <span class="borderShop" v-if="item.is_free_shipping==1">包邮</span>
            </div>

          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>

  export default {
    name: 'message',
    data () {
      return {
        msg: '',
        list:[],
        name:"",
        cartInfoList: [
          {
            id: 1,
            shopTitle: '苹果旗舰店', // 商店名
            checked: false, // 商店选择的状态
            checkedCount: 0, // 此商店被选择的商品数量
            productList: [
              {
                isChecked: false, // 商品选择状态
                productTitle: '2019款macbook/苹果/MF893/A国航笔记本', // 产品名
                category: '15寸/2.3/8G/256/土豪金/标准套餐',
                price: 10200, // 价格
                count: 1 // 数量
              }
            ]
          },
          {
            id: 2,
            shopTitle: '锤子科技旗舰店',
            checked: false,
            checkedCount: 0,
            productList: [
              {
                isChecked: false,
                productTitle: '锤子手机手感保护膜',
                category: '登陆月球',
                price: 9.9,
                count: 1
              },
              {
                isChecked: false,
                productTitle: '锤子手机pro割手版',
                category: '128G/割手版',
                price: 1790,
                count: 1
              }
            ]
          }
        ],
      }
    },
    methods:{
      backHistory(){
        this.$router.go(-1)
      },
      toShopDetail(id){
        this.$router.push({
          path:"/newShopDetail",
          query:{
            id:id
          }
        })
      },

      shopclassificationer(){
        this.$api.shopclassification()
          .then(res=>{
            this.categoryList=res.data
          })
      },
      getWrite(){
        this.$api.shopList({
          name:this.name
        })
          .then(res=>{
            this.list=res.data
            console.log(this.list)
          })
      },
    },
    mounted(){
      this.getWrite()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
  *{
    /*overflow-x:hidden;*/
    /*margin: 0;*/
    /*padding: 0;*/
  }
  header{
    width: 100%;
    /*height: 60px;*/
    background: #ff2500;
    position: fixed;
    z-index: 200;
    top: 0;
  }
  header img{
    width: 20px;
    height: 20px;
  }
  .headerDiv{
    display: flex;
    align-items: center;
    /*line-height: 70px;*/
  }
  .headerDiv p{
    margin: auto;
    font-size: 18px;
  }
  .searchDiv{
    width: 100%;
    /*display: flex;*/
    background-color: #6e9bcf;
    color: #fff;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 2;
  }
  .search{
    width: 90%;
  }
  .searchIcon{
    width: 10%;
    display: flex;
    align-items: center;
    background-color: #ff2500;
    color: #ffffff;
    font-size: 15px;
  }
  /deep/ .van-swipe{
    width: 100%;
    height: 100%;
  }
  .shopList{
    margin-top: 70px;
  }
  .shopListDetailsImg{
    width: 80px;
    height: 80px;
  }
  .shopListDetailsImg img{
    width: 100%;
    /*height: 100%;*/
  }
  .shopListDetails{
    display: flex;
    padding: 15px;
  }
  .shopRoduct{
    margin-left: 2rem;
    /*display: flex;*/
    /*flex-direction: column;*/
    /*justify-content: space-around;*/
    /*width: 60%;*/
  }
  .shopListDiv{
    padding: 10px;
  }
  .shopRoductM{
    display: flex;
    justify-content: space-between;
  }
  /deep/.van-submit-bar{
    bottom: 50px;
  }
  .shopSpan{
    display: block;
  }
  .borderShop{
    border: solid 1px red;
    /*display: block;*/
    font-size: 12px;
    color: red;
    padding: 3px;
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/shop/search.vue